module.exports = function (amount, options) {
    var numericAmount = typeof amount === 'string' ? options.contexts[0].get(amount) : amount;
    var pennies = Math.round(numericAmount * 100);
    var cents = pennies % 100;
    var dollars = Math.round(pennies / 100 - cents / 100);
    var centsStr = '' + cents;
    var result = '$' + dollars + '.' + (centsStr.length < 2 ? '0' + cents : cents);

    return result;
};